/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReceiverFundingIdColumnFormatter = (
  cellContent,
  row,
  rowIndex
) => {
  const { receiverFundingId } = row;

  return (
    <>
      <div className="d-flex align-items-center">
        {receiverFundingId ? receiverFundingId : `-`}
      </div>
      <> </>
    </>
  );
};
